import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import InformationCircleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/InformationCircleIconPath";
import { useTranslation } from "@coworker/locales";
import ModalColumn from "../../ModalColumn/ModalColumn";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import {
  ConventionFinal,
  ConventionOne,
  ConventionThree,
  ConventionTwo,
} from "@coworker/apprestructured/src/tasks/components/NamingGuidelinesPopup/NamingGuidelinesPopup";
import { useState } from "react";

export const NamingGuideLines = () => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <FixaListViewItem
        showDivider={false}
        title={t("namingGuideLinesString")}
        control="navigational"
        controlIcon="chevronRightSmall"
        leadingIcon={InformationCircleIconPath}
        onClick={() => setShowModal(true)}
      />
      <FixaInlineMessage
        variant="informative"
        title={t("locationsCreatedInFixaString")}
        body={t("locationsCreatedInFixaWillBeDeletedString")}
        ssrIcon={InformationCircleIconPath}
      />
      <FixaModal visible={showModal} handleCloseBtn={() => setShowModal(false)}>
        <FixaSheets
          header={<FixaModalHeader title={t("namingGuideLinesString")} />}
          footer={
            <FixaModalFooter
              children={
                <FixaButton
                  text={t("okIUnderstandString")}
                  onClick={() => setShowModal(false)}
                  type="primary"
                  fluid
                />
              }
            />
          }
          ariaLabel={t("namingGuideLinesString")}
          fullSize
        >
          <FixaModalBody>
            <ModalColumn gap="medium">
              <FixaText textStyle="Heading.S">
                {t("customLocationNamingGuidelinesWhyDoesThisMatter")}
              </FixaText>
              <FixaText
                textStyle="Body.M"
                dangerouslySetInnerHTML={{
                  __html: t("customLocationNamingGuidelinesThatsWhyItMatters"),
                }}
              />
              <FixaText textStyle="Heading.S">
                {t("customLocationNamingGuidelinesHowShouldTheLocationBeNamed")}
              </FixaText>
              <FixaText textStyle="Body.M">
                {t("customLocationNamingGuidelinesTheNamingShouldAdhere")}
              </FixaText>
              <ConventionOne />
              <ConventionTwo />
              <ConventionThree />
              <ConventionFinal />
            </ModalColumn>
          </FixaModalBody>
        </FixaSheets>
      </FixaModal>
    </>
  );
};
